import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { Recipe } from "@core/types";
import { recipeClient } from "@core/clients";

interface Props {
  recipeById: Recipe["id"];
  options?: UseQueryOptions<Recipe | null, any, Recipe | null, [string, Recipe["id"]]>;
}

const useGetRecipeByIdQuery = ({ recipeById, options }: Props) => {
  return useQuery(
    ["recipes", recipeById],
    async () => {
      return await recipeClient.getRecipeById(recipeById);
    },
    {
      ...options,
    }
  );
};

export default useGetRecipeByIdQuery;
